// Import kamus bahasa
import id from "@/language/locales/id";
import en from "@/language/locales/en";

export interface FeatureDetail {
  title: string;
  subtitle: string;
  description: string;
  imageUrl: string;
  seoTitle: string;
  seoDesc: string;
}

export const featureDetails: Record<string, FeatureDetail> = {
  "all-in-one-invitation": {
    title: "All-In-One Undangan Digital Platform",
    subtitle: "", 
    description: "", 
    imageUrl: "", 
    seoTitle: "Platform Undangan Digital Gratis Terlengkap di Indonesia",
    seoDesc: "Buat undangan digital gratis dengan fitur terlengkap. All-in-one platform untuk manajemen tamu, RSVP, hingga kirim kado digital dalam satu aplikasi.",
  },
  "whatsapp-broadcast": {
    title: "Sebar Otomatis Via WhatsApp",
    subtitle: "Sebarkan Undangan Lebih Cepat, Rapi, Dan Terstruktur",
    description: "Fitur Sebar Otomatis via WhatsApp di Elynk.co membantu kamu mengirim undangan digital ke banyak tamu tanpa perlu repot mengirim satu per satu secara manual.\n\nCukup siapkan daftar tamu, dan sistem akan membantu proses pengiriman undangan secara otomatis dan terstruktur.",
    imageUrl: "/images/features/landing-page/share-wa-auto.webp",
    seoTitle: "Kirim Undangan Digital via WhatsApp Otomatis & Cepat",
    seoDesc: "Cara sebar undangan digital ke ribuan kontak WhatsApp secara otomatis. Hemat waktu, tanpa manual, dan pastikan undangan sampai ke genggaman tamu.",
  },
  "qr-check-in": {
    title: "QR Code Check-In Buku Tamu",
    subtitle: "Check-in Tamu Lebih Cepat, Rapi, dan Tercatat Otomatis",
    description: "Fitur QR Code Check-in Buku Tamu di Elynk.co membantu proses registrasi kehadiran tamu menjadi lebih tertib dan efisien saat hari acara.\n\nSetiap tamu akan mendapatkan <strong>QR Code unik</strong> yang terhubung langsung dengan data undangan mereka.",
    imageUrl: "/images/features/landing-page/checkin-feature.webp",
    seoTitle: "Buku Tamu Digital dengan QR Code Check-in Cepat",
    seoDesc: "Modernkan resepsi Anda dengan QR Code Check-in. Buku tamu digital yang mempercepat antrean dan mencatat kehadiran tamu secara akurat dan otomatis",
  },
  "digital-envelope": {
    title: "Amplop Digital Otomatis",
    subtitle: "Terima Amplop Digital Dengan Aman, Praktis, dan Tercatat",
    description: "Fitur Amplop Digital Otomatis di Elynk.co memungkinkan tamu mengirimkan hadiah berupa uang secara online langsung melalui undangan digital.\n\nSemua proses dilakukan dalam satu sistem terintegrasi, sehingga lebih rapi, aman, dan mudah dipantau.",
    imageUrl: "/images/features/landing-page/amplop-digital.webp",
    seoTitle: "Fitur Amplop Digital: Terima Angpao & Kado via Transfer",
    seoDesc: "Terima kado pernikahan secara cashless dengan Amplop Digital. Aman, praktis, dan langsung masuk ke rekening Anda. Tanpa ribet urus kotak fisik!",
  },
  "custom-rsvp": {
    title: "Apa yang Bisa Kamu Atur?",
    subtitle: "Pertanyaan RSVP Yang Bisa Disesuaikan", 
    description: "Kamu Dapat Menentukan Sendiri Pertanyaan RSVP Sesuai Kebutuhan Acara, Seperti:\n\n• Konfirmasi Hadir, Tidak Hadir Atau Ragu\n• Jumlah Tamu Yang Akan Datang\n• Informasi Tambahan Yang Perlu Diketahui Penyelenggara\n\nSemua Pertanyaan Dapat Disesuaikan Agar Data Yang Masuk Benar-Benar Relevan.",
    imageUrl: "/images/features/landing-page/interrogation.png",
    seoTitle: "Fitur Custom RSVP Undangan Digital Terlengkap",
    seoDesc: "Kelola konfirmasi kehadiran tamu dengan formulir RSVP yang dapat dikustomisasi pertanyaannya sesuai kebutuhan acara.",
  },
  "event-reminders": {
    title: "Reminder Acara Otomatis",
    subtitle: "Pengingat Acara yang Bekerja Otomatis untuk Kamu",
    description: "Reminder acara otomatis di elynk.co memastikan tamu yang sudah mengisi rsvp tidak lupa dengan jadwal acara.\n\nSistem akan mengirimkan pengingat secara otomatis menjelang hari h melalui <strong>WhatsApp</strong> dan <strong>Email</strong>. Kamu tidak perlu lagi mengingatkan tamu satu per satu secara manual.",
    imageUrl: "/images/features/landing-page/notif-reminder.webp",
    seoTitle: "Fitur Reminder Acara Otomatis: Pastikan Tamu Tak Lupa",
    seoDesc: "Kirim pengingat otomatis kepada tamu H-1 atau beberapa jam sebelum acara dimulai. Tingkatkan kehadiran tamu di hari spesial Anda dengan Elynk",
  },
  "multi-event-access": {
    title: "Split Acara Setiap Tamu",
    subtitle: "Satu Undangan, Banyak Acara dengan Kontrol Penuh",
    description: "Fitur Split Acara Setiap Tamu di Elynk.co memungkinkan kamu membuat beberapa sesi acara dalam satu undangan digital seperti akad, resepsi, after party, atau sesi khusus lainnya.\n\nYang membedakan, <strong>setiap tamu hanya dapat mengakses acara yang memang ditujukan untuknya.</strong>",
    imageUrl: "/images/features/landing-page/more-email.webp",
    seoTitle: "Manajemen Split Acara: Pisahkan Sesi Tamu Undangan",
    seoDesc: "Atur sesi kehadiran tamu dengan fitur Split Acara. Cocok untuk membagi jadwal tamu VIP atau umum agar lokasi acara tidak terlalu padat (crowd control).",
  },
  "gift-registry": {
    title: "Titip Kado Otomatis",
    subtitle: "Kirim Kado Lebih Praktis, Tanpa Repot Koordinasi",
    description: "Fitur Titip Kado Otomatis di Elynk.co memungkinkan tamu memilih dan membeli kado langsung melalui undangan digital.\n\nElynk yang akan menyiapkan dan mengirimkan kado tersebut ke alamat tujuan. Kamu tidak perlu lagi mengatur pengiriman kado secara manual dengan tamu.",
    imageUrl: "/images/features/landing-page/gift-auto.webp",
    seoTitle: "Layanan Titip Kado Otomatis: Kirim Hadiah Tanpa Ribet",
    seoDesc: "Mudahkan tamu yang berhalangan hadir untuk tetap berkirim hadiah melalui fitur Titip Kado Otomatis. Integrasi pengiriman kado langsung ke alamat Anda.",
  }
};

export const getLocalizedFeatureDetails = (locale: string): Record<string, FeatureDetail> => {
  const langData = locale === 'en' ? en : id;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const featuresLang = (langData.LandingPage as any).features;

  const localizedData: Record<string, FeatureDetail> = {};

  for (const key in featureDetails) {
    localizedData[key] = {
      imageUrl: featureDetails[key].imageUrl,
      title: featuresLang?.[key]?.title || featureDetails[key].title,
      subtitle: featuresLang?.[key]?.subtitle || featureDetails[key].subtitle,
      description: featuresLang?.[key]?.description || featureDetails[key].description,
      seoTitle: featuresLang?.[key]?.seoTitle || featureDetails[key].seoTitle,
      seoDesc: featuresLang?.[key]?.seoDesc || featureDetails[key].seoDesc,
    };
  }

  return localizedData;
};